import React from "react";
import { GroupTitle } from "./GroupTitle";
import { SignatureLineElement, SignatureDivElement } from "./SignatureLineElement";
import { TableElement } from "./TableElement";
import { TextElement } from "./TextElement";

export const Group = ({ title, number, data }) => {
  const addGroupElement = item => {
    switch (item?.type) {
      case "table":
        return TableElement(item.table, item.groupOptions, item.title);
      case "text":
        return TextElement(item.data);
      case "signatureLine":
        return SignatureLineElement(item.data);
      case "signatureDiv":
        return SignatureDivElement(item.data, item.title);
      case "composedDivs":
        return (
          <div className="avoidPageBreakInside">{item.data.map(itm => addGroupElement(itm))}</div>
        );
      default:
        return <></>;
    }
  };
  return (
    <div className="row pt-3 no-page-break mx-0">
      <GroupTitle number={number} title={title} />
      <div className="col-12 ">
        {data?.map(item => {
          return addGroupElement(item);
        })}
      </div>
    </div>
  );
};
